import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function Luftfragt() {
  return (
    <>
      <SEO
        title="Luftfragt | Fastlane ApS"
        description="Via vores globale netværk af udvalgte leverandører arrangerer vi luftfragt til og fra destinationer i hele verden. Hurtig og præcis transport."
        canonicalUrl="https://fastlane.dk/luftfragt-0"
      />

      <PageHeader
        title="Luftfragt"
        subtitle="Hurtig og præcis flytransport til og fra destinationer i hele verden."
        breadcrumbs={[
          { label: 'Ydelser', path: '/godstransport-i-europa' },
          { label: 'Luftfragt' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <p>
              Via vores globale netværk af udvalgte leverandører arrangerer vi luftfragt til og fra destinationer i hele verden.
            </p>
            <p>
              Luftfragt er hurtig og præcis transport. Enten som et alternativ eller supplement til søfragt ved eksport eller import af gods over lange distancer.
            </p>
            <p>
              Vores målsætning er at finde det bedste match mellem den konkrete transportopgave og flytransport, således at luftfragtsraten bliver konkurrencedygtig.
            </p>
          </div>

          <div className="p-5 bg-sky-50 rounded-xl border border-sky-200 text-sky-950 font-semibold">
            Volumen-/vægtforholdet er 167 kgs per kubikmeter.
          </div>

          <div className="bg-slate-50 p-6 sm:p-8 rounded-2xl border border-slate-200 space-y-4">
            <h2 className="text-xl font-bold text-[#0f2b48]">
              Det bedste flyrater opnås ved en præcis beskrivelse af godset m.h.t.:
            </h2>
            <ul className="space-y-2 text-sm sm:text-base text-slate-700">
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>L x B x H</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>vægt</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>godstype</span>
              </li>
            </ul>
          </div>

          <div className="space-y-4 text-slate-700 leading-relaxed text-base">
            <p>
              Luftfragtsraterne kan svinge en del som følge af sæsonudsving el. blot et travlt marked. Udsvingene kan godt være lokalt i et geografisk område så det giver god mening at undersøge.
            </p>
            <p>
              Godsdimensionerne påvirker ikke kun luftfragtsprisen, men kan være afgørende for, hvorvidt et fly der kan benyttes eller ej.
            </p>
            <p>
              Vi anvender leverandører som arbejder i.h.t. The Air Transport Association el. blot IATA. Farligt gods er altid kritisk når der er tale om luftfragt fordi reglerne typisk er skærpede m.h.t. dokumentation, pakning, emballering og mærkning.
            </p>
            <p>
              Luftfragt foregår typisk mellem 2 eller flere lufthavne. Altså er det normalt med lokalkørsel i begge ender d.v.s. fra afsender til lufthavn og fra lufhavn til modtager. Ligeledes vil luftfragt ofte inkludere en udførsel i afsenderlandet og en fortoldning i modtager landet. Vi tilbyder gerne dør til dør rater, som inkluderer alle omkostningerne på nær importtold, importmoms, tredjeparts intervention og lign.
            </p>
          </div>

          {/* Lande */}
          <div className="p-6 bg-slate-50 rounded-2xl border border-slate-200">
            <h3 className="text-lg font-bold text-[#0f2b48] mb-2">Et udpluk af de lande vi betjener:</h3>
            <p className="text-sm sm:text-base text-slate-700 leading-relaxed font-medium">
              USA, Canada, Grønland, Kina, Japan, Indien, Brasilien, Argentina, Chile, Australien og Sydafrika
            </p>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">Har du en hasteforsendelse med luftfragt?</span>
            <Link
              to="/fragtrater"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Forespørg pris på luftfragt
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
